import mitt from 'mitt'

export const EventManager = mitt()
